import TimeInput, { ITimeInputProps } from './TimeInput'

export { ITimeInputProps }

export default TimeInput
